// React
import React from "react";
import { useNavigate } from "react-router-dom";

// Libraries
import { Container, Button } from "semantic-ui-react";

// Components
import Screen from "@Components/Screen";
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const NoMatch = () => {
	const navigate = useNavigate();

	const handleHomepage = () => {
		navigate("/", { replace: true });
	};

	return (
		<Screen>
			<Container>
				<div className={styles.container}>
					<Text className={styles.title}>Oops!</Text>
					<Text className={styles.subTitle}>404 - Page Not Found</Text>
					<div className={styles.paragraphContainer}>
						<Text className={styles.paragraph}>
							The page you are looking for might have been removed had its name changed or is temporarily unavailable.
						</Text>
					</div>

					<Button className={styles.button} onClick={handleHomepage}>
						Go To Homepage
					</Button>
				</div>
			</Container>
		</Screen>
	);
};

export default NoMatch;
